import { render } from "./DashboardLayer.vue?vue&type=template&id=5a9e836f&scoped=true"
import script from "./DashboardLayer.vue?vue&type=script&lang=js"
export * from "./DashboardLayer.vue?vue&type=script&lang=js"

import "./DashboardLayer.vue?vue&type=style&index=0&id=5a9e836f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9e836f"]])

export default __exports__